module.exports = __webpack_public_path__ + "static/media/asl logo.dac5f847.png";